import { memo } from "react";
import { DetailedInfo } from "./detailed-info";
import { Highlight } from "./highlight";
import * as Styled from "./style";
import type { G_GetVideoQuery } from "~/lib/graphql";

type ProductDescriptionProps = {
  videoData: G_GetVideoQuery["video"];
};

/**
 * 見どころブロックと詳細情報ブロックを包括したコンポーネント
 * @param props {@link ProductDescriptionProps}
 *
 * @機能要件
 * - 見どころ情報が存在しない場合 : 見どころタイトル and 見どころ情報を表示しないこと
 * - 見どころ情報にHTMLタグは入るかどうか : HTMLタグは入らない
 * - 詳細情報が存在しない場合 : 詳細情報タイトル and 詳細情報を表示しないこと
 * - 詳細情報にHTMLタグは入るかどうか : グラビア、舞台、VRなど既存納品経路のコンテンツの「詳細情報」のみ文字列ではなくHTMLタグが返却される
 */
export const ProductDescription = memo((props: ProductDescriptionProps) => {
  const { videoData } = props;

  return (
    <Styled.ArtRoot>
      <Highlight videoData={videoData} />
      <DetailedInfo videoData={videoData} />
    </Styled.ArtRoot>
  );
});

ProductDescription.displayName = "ProductDescription";
